import { type MetaFunction } from '@remix-run/node'
import { Link } from '@remix-run/react'

export const meta: MetaFunction = () => [
	{ title: 'Frequently Asked Questions' },
	{
		name: 'description',
		content:
			'Answers to common questions about insurance and financial planning',
	},
]
export default function Component() {
	return (
		<main className="mx-auto my-10 max-w-7xl">
			<Link to="/" prefetch="intent" className="text-blue-600 underline">
				Home
			</Link>

			<div className="bg-white">
				<div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-20">
					<div className="lg:grid lg:grid-cols-3 lg:gap-8">
						<div>
							<h2 className="text-3xl font-extrabold text-gray-900">
								Frequently asked questions
							</h2>
							<p className="mt-4 text-lg text-gray-500">
								Can't find the answer you're looking for? Reach out to our{' '}
								{/* TODO: Fix this link */}
								{/* <Link
									to="customer-support"
									className="font-medium text-indigo-600 hover:text-indigo-500"
									prefetch="intent"
								> */}
								customer support {/* </Link>{' '} */}
								team.
							</p>
						</div>
						<div className="mt-12 lg:col-span-2 lg:mt-0">
							<ul className="space-y-12">
								<li className="text-lg font-medium leading-6 text-gray-900">
									<Link
										to="/frequently-asked-questions/is-insurance-a-bad-deal-if-i-dont-place-a-claim/"
										className="text-blue-600 underline"
										prefetch="intent"
									>
										Is Insurance a <em>Bad Deal</em> if I don't place a claim?
									</Link>
								</li>
								<li className="text-lg font-medium leading-6 text-gray-900">
									<Link
										to="/frequently-asked-questions/do-i-need-to-buy-the-extra-insurance-offered-by-car-rental-companies/"
										className="text-blue-600 underline"
										prefetch="intent"
									>
										Do I need to buy the extra insurance offered by car rental
										companies?
									</Link>
								</li>
								<li className="text-lg font-medium leading-6 text-gray-900">
									<Link
										to="/frequently-asked-questions/why-is-my-home-insured-for-more-than-my-assessment/"
										className="text-blue-600 underline"
										prefetch="intent"
									>
										Why is my home insured for more than my assessment?
									</Link>
								</li>
								<li className="text-lg font-medium leading-6 text-gray-900">
									<Link
										to="/frequently-asked-questions/insurance-for-uber-and-lyft-drivers/"
										className="text-blue-600 underline"
										prefetch="intent"
									>
										How does driving for a ride sharing or transportation
										network company ("TNC") such as Uber or Lyft affect my auto
										insurance coverage?
									</Link>
								</li>
								<li className="text-lg font-medium leading-6 text-gray-900">
									<Link
										to="/frequently-asked-questions/is-it-more-expensive-to-buy-insurance-from-an-agent/"
										className="text-blue-600 underline"
										prefetch="intent"
									>
										Is it more expensive to buy insurance from an agent?
									</Link>
								</li>
								<li className="text-lg font-medium leading-6 text-gray-900">
									<Link
										to="/frequently-asked-questions/how-will-they-know-what-stuff-was-in-my-house-if-i-have-a-claim/"
										className="text-blue-600 underline"
										prefetch="intent"
									>
										How will they know what stuff was in my house if I have a
										claim?
									</Link>
								</li>
								{/* <li className="text-lg font-medium leading-6 text-gray-900">
									<Link
										to="/frequently-asked-questions/what-is-ameritas-investments/"
										className="text-blue-600 underline"
										prefetch="intent"
									>
										Why do you answer the phone "Steele Agency and Ameritas
										Investments?"
									</Link>
								</li> */}
							</ul>
						</div>
					</div>
				</div>
			</div>

			{/*
    <p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>How do they determine the replacement cost of my home?</p>
    <p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>Can I lower my coverage?</p>
    <p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
      Why can't I select a lower amount of coverage than the replacement cost,
      but still have the benefits of having the policy pay out 100% of claims up
      to the policy limit
    </p>
    <p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
      Because there is such a thing as coinsurance. Your policy may contain a
      requirement that you insure for 80%, 90%, or 100% of the replacement cost.
      In order to determine the replacement cost, these are the types of
      questions that may need to be answered:
    </p>
    <p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
      <ul>
        <li  className="text-lg leading-6 font-medium text-gray-900">When was the home originally built/ how old is it?</li>
        <li>
          Was it built out of bricks, wood, or something else? (What is it made
          out of?)
        </li>
        <li>how big is the home?</li>
        <li>Is it a one story or two story or something different?</li>
      </ul>
    </p>
*/}
			{/* 
	<em>What is this "Law Enforcement Fee" on my Automobile policy?</em>
				The Motor Vehicle Law Enforcement Fee that you see on your automobile
				policy is a $10 fee per vehicle. It's part of a NY State program to
				raise funds for state police officers and combat insurance-related fraud
				crime.
				 */}
		</main>
	)
}
